import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { EncrDecrService1 } from './encr-decr.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private enceService: EncrDecrService1) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (localStorage.getItem('info') && this.checkTokenExpiration()) {
      return true;
    } else {
      this.router.navigateByUrl('/login');
      return false;
    }
  }

  checkTokenExpiration(): boolean {
    if (localStorage.getItem('info')) {
      const data = JSON.parse(localStorage.getItem('info'));
      const EXP_DATE = new Date(data.expiration);

      if (EXP_DATE < new Date(Date.now())) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  }
}
